/**
 * Controller: PricingDiscountsRemoveModal
 */
angular.module('acme.view.application.pricing.discounts.removeModal.controllers', [])
.controller('PricingDiscountsRemoveModalController', [ '$scope', '$uibModalInstance', 'currentDiscount', function ($scope, $uibModalInstance, currentDiscount) {

    $scope.errors = [];

    $scope.model = {
      name: currentDiscount.name
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close(true);
    };

    $scope.init();

  }]);